import { UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel, UIComponentProps } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { ToneDto } from '../../../../../core/dto/tonedto';
import { SearchlistViewImpl } from './searchlistview';
import { SearchlistCSSStyleImpl } from './searchlistcss';
import { ListViewModel } from '../../../../toolkit/horizontallist/listviewmodel';
import { SearchAPIModelImpl } from '../searchapimodel';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';

export interface SearchlistComponentProps extends UIComponentProps
{
    listViewModel: ListViewModel<ToneDto>;

    onLoadMore(startIndex: number, offset: number): void;
}

export interface SearchlistComponentHandler extends UIComponentHandler
{
    onLoadMore(startIndex: number, offset: number): void;
}

export class SearchlistComponent extends UIComponentImpl<SearchlistComponentProps, UIComponentState, UIDataModel> 
implements SearchlistComponentHandler
{
    constructor(props: SearchlistComponentProps)
    {
        super(props);

        this.onLoadMore = this.onLoadMore.bind(this);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new SearchlistViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new SearchlistCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return  new SearchAPIModelImpl(applicationContext, apiModelHandler);
    }

    updatePaginationCount()
    {
        (this.getView() as SearchlistViewImpl).updatePaginationCount();
    }

    resetPaginationCount()
    {
        (this.getView() as SearchlistViewImpl).resetPaginationCount();
    }

    // updateListOfData(listOfDatas: ToneDto[])
    // {
    //     this.props.listViewModel.getListOfDatas().length = 0;
    //     this.props.listViewModel.setListDatas(listOfDatas);

    //     this.forceUpdateComponent();
    // }

    // onSuccess(feature: APIFeatures, description: string, data: any): void 
    // {
    //     console.log("----title: " + this.props.title);
    //     if(this.props.title === this.props.context.getResources().getString(Strings.tones))
    //     {
    //         this.updateListOfData((data as SpecificSearchToneDto).getToneList());
    //         (this.getView() as SearchlistViewImpl).updatePaginationCount();
    //     }
    //     // else
    //     // {
    //     //     this.updateListOfData((data as SpecificSearchToneDto).getCountList().getArtistDetailList());
    //     //     (this.getView() as SearchlistViewImpl).updatePaginationCount();
    //     // }
    // }

    onLoadMore(startIndex: number, offset: number): void 
    {
        this.props.onLoadMore(startIndex, offset);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/search/playlist/searchlistcomponent.tsx